export const PROD_URL = 'https://main.dcocz4f0lb5ws.amplifyapp.com';
export const DEV_URL = 'http://localhost:3000';
export const BACKEND_URL = process.env === 'development' ? DEV_URL : PROD_URL; //TODO AUTOMATE SYSTEM VARIABLE
export const background_url_dev = `${PROD_URL}/assets/Background_HD.png`; //TODO PROD: PROD_URL
export const logo_url_dev = `${PROD_URL}/assets/icon/logo.png`; //TODO PROD: PROD_URL
export const piedino_asobike = `${PROD_URL}/assets/piedino_asobike.png`; //TODO PROD: PROD_URL
